<template>

    <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">
        <v-toolbar tabs fixed light color="white">
            <v-btn icon @click.native="closeDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedItem.id === 0">Add Supplier Offer</v-toolbar-title>
            <v-toolbar-title v-else>Edit Supplier Offer - {{selectedItem.offer_number}}
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tabs slot="extension"
                    v-model="activeTab"
                    color="secondary"
                    dark
                    slider-color="primary"
                    class="fixSides"
                    show-arrows

            >
                <v-tab>SUPPLIER OFFER</v-tab>
                <v-tab :disabled="tabsDisabled">SUPPLIER OFFER POSITIONS</v-tab>
            </v-tabs>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-tabs-items class="fromTop" v-model="activeTab"
                      :touchless="touchless"
        >
            <v-tab-item>

                <v-layout wrap>
                    <v-container grid-list-md>
                        <v-flex xs12 md10 offset-md1 xl6 offset-xl3>
                            <v-hover>
                                <v-card slot-scope="{ hover }"
                                        :class="`elevation-${hover ? 4 : 1}`">
                                    <v-card-title class="headline">Supplier Offer
                                        <v-spacer></v-spacer>
                                    </v-card-title>

                                    <v-card-title>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Supplier</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            clearable
                                                            :items="getAllSuppliers"
                                                            label="Supplier"
                                                            v-model="selectedItem.suppliers_id"
                                                            item-value="id"
                                                            item-text="name"
                                                            :loading="loading"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            class="contactPerson"
                                                            label="Contact Person"
                                                            v-model="selectedItem.suppliers_contacts_id"
                                                            persistent-hint
                                                            :items="getSupplierContacts"
                                                            :filter="customContactFilter"
                                                            item-value="id"
                                                            item-text="name"
                                                            clearable
                                                            :loading="loading"

                                            >
                                                <template slot="selection" slot-scope="data">
                                                    {{ data.item.title ? data.item.title : '' }} {{
                                                    data.item.firstname
                                                    }} {{
                                                    data.item.lastname }}
                                                </template>

                                                <template slot="item" slot-scope="data">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>
                                                            {{ data.item.title ? data.item.title : '' }} {{
                                                            data.item.firstname }} {{
                                                            data.item.lastname }}
                                                        </v-list-tile-title>

                                                        <v-list-tile-sub-title v-if="data.item.main_contact"
                                                        >Main Contact
                                                        </v-list-tile-sub-title>

                                                    </v-list-tile-content>
                                                </template>

                                                <template slot="no-data">
                                                    <v-layout wrap>
                                                        <v-flex xs12 pl-4 pr-4>
                                                            <v-btn @click.native="openNewSupplierContactDialog()" block
                                                                   small flat color="secondary">Create New contact
                                                                <v-icon>add</v-icon>
                                                            </v-btn>
                                                        </v-flex>

                                                    </v-layout>
                                                </template>

                                            </v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Offer</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>

                                            <v-text-field
                                                    v-show="!getInitialLoading"
                                                    label="Offer Number"
                                                    v-model="selectedItem.offer_number"
                                                    counter
                                                    maxlength="255"
                                            ></v-text-field>
                                        </v-flex>


                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <UploadDocumentPicker v-show="!getInitialLoading"
                                                                  v-model="uploadedDocument"
                                                                  label="Select PDF"
                                            >
                                            </UploadDocumentPicker>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            clearable
                                                            v-model="selectedItem.currencies_id"
                                                            :items="getCurrencies"
                                                            label="Currency"
                                                            item-value="id"
                                                            item-text="name"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <v-layout>
                                                <v-spacer></v-spacer>
                                                <DocumentTokenChip
                                                        v-show="selectedItem.documents_id !== 0 && !getInitialLoading"
                                                        :documentsId="selectedItem.documents_id"
                                                        :documentFilename="selectedItem.offer_number + '.pdf'"
                                                >
                                                </DocumentTokenChip>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            :items="termsOfDelivery"
                                                            item-text="name"
                                                            item-value="id"
                                                            label="Term of Delivery"
                                                            v-model="selectedItem.terms_of_deliveries_id"
                                                            required
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete
                                                    v-show="!getInitialLoading"
                                                    :items="termsOfPayment"
                                                    item-text="name"
                                                    item-value="id"
                                                    label="Term of Payment"
                                                    v-model="selectedItem.terms_of_payments_id"
                                                    required
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <DatetimePicker  v-show="!getInitialLoading"
                                                             locale="de-DE"
                                                             landscape
                                                             mysql
                                                             :width="width = 500"
                                                             label="Received at"
                                                             v-model="selectedItem.received_at"
                                                             format="DD.MM.YYYY HH:mm"
                                            >
                                            </DatetimePicker>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <DatetimePicker  v-show="!getInitialLoading"
                                                    locale="de-DE"
                                                    landscape
                                                    dateOnly
                                                    mysql
                                                    :width="width = 500"
                                                    label="Valid Until"
                                                    v-model="selectedItem.valid_until"
                                                    format="DD.MM.YYYY"
                                            >
                                            </DatetimePicker>
                                        </v-flex>
                                        <!--                                        <ProcessHistory
                                                                                        :historyTypeID="selectedItem.histories_types_id"
                                                                                        :itemID="selectedItem.id"
                                                                                        :selectedItem="selectedItemForHistory"
                                                                                ></ProcessHistory>-->

                                    </v-card-title>

                                    <v-card-actions>
                                        <v-layout mt-2 pb-3 pr-3>
                                            <v-spacer></v-spacer>
                                            <v-btn :loading="saveProcess" color="secondary"
                                                   @click.native="saveAndGoToNextTab(1)">
                                                Save
                                                <v-icon class="white--text" right>save</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-hover>
                            <v-layout mt-5 row justify-end>
                            </v-layout>
                        </v-flex>

                    </v-container>
                </v-layout>
            </v-tab-item>
            <v-tab-item>
                <supplierOfferPositions></supplierOfferPositions>
            </v-tab-item>
        </v-tabs-items>
    </v-card>

</template>

<script>
    import {
        Settings,
        Procurement,
        SupplierOffers,
        ContactPersonSettings
    } from '../../store/namespace-helper'
    import supplierOfferPositions from '../SupplierOffers/SupplierOfferPositions/SupplierOfferPositions.vue'
    import DatetimePicker from '../Shared/DatetimePicker.vue'
    import UploadDocumentPicker from '../Shared/UploadDocumentPicker.vue'
    import DocumentTokenChip from '../Shared/DocumentTokenChip.vue'
    import FakeItem from '../Shared/FakeItem.vue'
    import FakeTable from '../Shared/FakeTable.vue'
    import ProcessHistory from '../Shared/ProcessHistory.vue'

    import {dateFunctionFilters} from '../../mixins/dateFunctionFilters'
    import {initialLoadingMixin} from '../../mixins/initialLoadingMixin'

    /*   import _ from 'lodash' */

    export default {
      components: {
        supplierOfferPositions,
        DatetimePicker,
        UploadDocumentPicker,
        DocumentTokenChip,
        FakeItem,
        FakeTable,
        ProcessHistory
      },
      name: 'add-supplier-offer',
      mixins: [dateFunctionFilters, initialLoadingMixin],
      data () {
        return {
          activeTab: 0,
          headers: [
                    {text: 'Offer-ID', value: 'id'},
                    {text: 'Offer Number', value: 'offer_number'},
                    {text: 'Account', value: 'accounts_id'},
                    {text: 'Status', value: 'customers_offers_status_id'},
                    {text: 'Valid Until', value: 'valid_until'}
          ],
          countries: this.$store.getters.countries,
          selectedOffers: [],
          selectedOfferIDs: [],
          pagination: {'sortBy': 'id', 'descending': true},
          search: '',
          total: 0,
          rowsPageItems: [5, 10, 25, 50, 100, 250],
          customContactFilter (item, queryText, itemText) {
            const isMatch = (test, query) => {
              return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
            }
            const query = queryText || ''
            const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
            const rc = isMatch(item.firstname, query) ||
                        isMatch(item.lastname, query) ||
                        isMatch(item.email, query) ||
                        isMatch(displayText, query)
            console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
            return rc
          },
          isVisible: false,
          supplierContact: {},
          supplierUpdated: 0,
          onDismissed: false,
          sheet: false,
          searchCustomer: '',
          searchCustomerBranchOffice: '',
          searchCustomerBranchOfficeContact: '',
          valid_until: '',
          statuses: [],
          allAccounts: [],
          touchless: true,
          uploadedDocument: null,
          selectedItemForHistory: null,
          saveProcess: false
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadCurrencies()
              this.loadTermsOfDeliveries()
              this.loadTermsOfPayments()
                        /*           this.loadSelectedItemForHistory() */
              this.loadAllSuppliers()
              this.initialLoadingTimeout(850)
            } else {
              this.supplierUpdated = 0
              this.resetInitialLoadingState()
            }
          }
        },
        closeDialog () {
          this.$store.dispatch(SupplierOffers.actions.setSelectedSupplierOffer, null)
          this.$store.dispatch(SupplierOffers.actions.openCloseDialog)
          this.activeTab = 0
        },
        loadCurrencies () {
          this.$store.dispatch(Settings.actions.loadAllCurrencies)
        },
        loadTermsOfPayments () {
          this.$store.dispatch(Settings.actions.loadTermsOfPayments)
        },
        loadTermsOfDeliveries () {
          this.$store.dispatch(Settings.actions.loadTermsOfDeliveries)
        },
        loadSelectedItemForHistory () {
          this.$store.dispatch(Procurement.actions.loadProcurement, this.selectedItem).then(response => {
            this.selectedItemForHistory = response.data.data
          })
        },
        saveAndGoToNextTab (index) {
          this.saveProcess = true
          let supplierOffer = {
            id: this.selectedItem.id,
            inquiries_id: this.selectedItem.inquiries_id,
            offer_number: this.selectedItem.offer_number,
            valid_until: this.selectedItem.valid_until,
            received_at: this.selectedItem.received_at,
            terms_of_deliveries_id: this.selectedItem.terms_of_deliveries_id,
            terms_of_payments_id: this.selectedItem.terms_of_payments_id,
            documents_id: this.selectedItem.documents_id,
            suppliers_contacts_id: this.selectedItem.suppliers_contacts_id,
            currencies_id: this.selectedItem.currencies_id,
            suppliers_id: this.selectedItem.suppliers_id
          }
          this.$store.dispatch(SupplierOffers.actions.saveSupplierOffer, supplierOffer).then(response => {
                    // this.activeTab = index
                    /*        this.loadSelectedItemForHistory() */
            this.saveProcess = false
          }).catch(err => {
            this.saveProcess = false
            console.log('err: ' + JSON.stringify(err))
          })
        },
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        },
        loadSupplierContacts (val) {
          this.$store.dispatch(ContactPersonSettings.actions.loadContactPersonsBySupplierId, val)
        },
        loadAllSuppliers: function () {
          this.$store.dispatch(Settings.actions.loadAllSuppliers)
        }
      },
      computed: {
        selectedItem () {
          return this.$store.getters[SupplierOffers.getters.getSelectedSupplierOffer]
        },
        getSupplierContacts () {
          return this.$store.getters[ContactPersonSettings.getters.getContactPersonsForSupplierId]
        },
        getAllSuppliers () {
          return this.$store.getters[Settings.getters.getAllSuppliers]
        },
        getCurrencies () {
          return this.$store.getters[Settings.getters.getAllCurrencies]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        tabsDisabled () {
          return this.$store.getters[SupplierOffers.getters.getSelectedSupplierOffer].id === 0
        },
        termsOfPayment () {
          return this.$store.getters[Settings.getters.getTermsOfPayments]
        },
        termsOfDelivery () {
          return this.$store.getters[Settings.getters.getTermsOfDeliveries]
        }
      },
      watch: {
        'selectedItem.suppliers_id': {
          handler (val) {
            if (val !== null) {
              if (val !== 0) {
                this.loadSupplierContacts(val)
              }
            }
          }
        },
        uploadedDocument: {
          handler (val) {
            this.selectedItem.documents_id = val.id
            console.log('uploadedDocuments id: ' + JSON.stringify(val))
          },
          deep: true
        }
      }

    }
</script>


<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .fromTop {
        padding-top: 120px;
    }

    .fixSides::before {
        position: absolute;
        content: "";
        background-color: var(--secondary-color);
        height: 100%;
        width: 110vw;
        top: 0px;
        left: -24px;
    }

    .statusSelecter {
        width: 80px;
    }

    .process-history {
        text-align: right;
        width: 100%;
        font-size: 0.95rem;
    }

</style>


// WEBPACK FOOTER //
// src/components/SupplierOffers/AddSupplierOffer.vue